// this is the global reducer

import { reducer as toastr } from "react-redux-toastr";

// import { combineReducers } from "./utility/combineReducers";
import { combineReducers } from "redux";
import countryReducer, {
  loginReducer as loginInfo,
  signupReducer as signupInfo,
  forgotPasswordReducer as forgotPasswordInfo,
  resendActivationReducer as resendActivationInfo,
  logoutReducer as logoutInfo
} from "./Containers/Login/reducer";
import { subscribePlanReducer as subscribePlanInfo } from "./Containers/Pricing/reducer";
import { fileUploadReducer as fileUpload } from "./Containers/BulkValidation/reducer";
import { validateEmailReducer as validateEmail } from "./Containers/SingleEmailValidation/reducer";
// import { contacts } from './containers/Contacts/reducer';

import { routerReducer } from "react-router-redux";

import { dashboardReducer as dashboardInfo } from "./Containers/Dashboard/reducers";
import { CompanyProfileInfoReducer, EmailVerificationReducer as emailverificationinfo } from "./Containers/EmailValidation/reducer";
import { settingsReducer as settingsInfo } from "./Containers/Settings/reducer";

const rootReducer = combineReducers({
  loginInfo,
  signupInfo,
  forgotPasswordInfo,
  resendActivationInfo,
  fileUpload,
  validateEmail,
  dashboardInfo,
  emailverificationinfo,
  toastr,
  router: routerReducer,
  subscribePlanInfo,
  settingsInfo,
  logoutInfo,
  countries: countryReducer,
  companyProfileInfo: CompanyProfileInfoReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers.js